import { Component} from '@angular/core';
import { Injectable } from '@angular/core';
import {NgbModal, ModalDismissReasons,NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  constructor(private modalService: NgbModal,public activeModal: NgbActiveModal) {}
  public title: string;
  public message: string;
}

  @Injectable()
  export class ModalService {
    constructor(private modalService: NgbModal) {}

  public show(title: string, message:string) {
    const modalRef = this.modalService.open(ModalComponent, {backdrop:false});
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    return modalRef.result; 
  }
}
